import { useState } from "react";
import { motion } from "framer-motion";
import styles from "./TattooGalleryItem.module.css";

const TattooGalleryItem = ({
  id,
  src,
  alt,
  aspectRatio,
  index,
  onClick,
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <button
      type="button"
      className={styles.card}
      style={{
        "--card-aspect-ratio": aspectRatio,
        "--reveal-delay": `${(index % 6) * 60}ms`,
      }}
      onClick={onClick}
      aria-label={`View larger version of ${alt}`}
    >
      {!loaded && <div className={styles.skeleton} />}

      <motion.img
        layoutId={`tattoo-image-${id}`}
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        className={`${styles.image} ${loaded ? styles.loaded : ""}`}
        onLoad={() => setLoaded(true)}
        transition={{
          layout: {
            duration: 0.55,
            ease: [0.16, 1, 0.3, 1],
          },
        }}
      />
    </button>
  );
};

export default TattooGalleryItem;